import React, {
  useState,
  FC,
  PropsWithChildren,
} from 'react'
import clsx from 'clsx'

export const Tooltip: FC<
  PropsWithChildren<{ text: string }>
> = ({ children, text, className }) => {
  const [show, setShow] = useState(false)

  return (
    <div
      className={clsx('tooltip', className)}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {text && 
        <div className={clsx('tooltipPopup', { show: show })}>
          {text}
          <span className="tooltipArrow" />
        </div>
      }
    </div>
)
}
